import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { VirginiaClaimReportFieldEnum as Fields } from 'Common/FieldEnum';
import { Filter, Main } from 'Containers/';
import VirginiaClaimReportForm from './components/VirginiaClaimReportForm';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { VIRGINIA_CLAIM_REPORT_FORM_NAME } from 'Common/FormEnum';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import { withReportSubscription } from 'State/report/withReportSubscription';

function VirginiaClaimReportContainer({ getReport, reportFetching }) {
  const getMainProps = () => {
    return {
      toolbox: {
        formName: VIRGINIA_CLAIM_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: reportFetching,
          disabled: reportFetching,
        },
        shown: true,
      },
    };
  };

  const handleSubmit = async (values) => {
    getReport('reports/VirginiaIncomeReport', values);
  };

  return (
    <Fragment>
      {reportFetching && <LoadingPage />}
      <Filter title={'VA SNP Claim Form'} />
      <Main {...getMainProps()}>
        <VirginiaClaimReportForm
          onSubmit={handleSubmit}
          initialValues={{
            [Fields.MonthYear]: moment().format(MONTH_YEAR_DATE_FORMAT),
            [Fields.Sites]: [],
          }}
        />
      </Main>
    </Fragment>
  );
}

export const VirginiaClaimReport = withReportSubscription(
  connect()(VirginiaClaimReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/virginiaclaimreport/VirginiaClaimReport.js